import { Center, Text3D } from '@react-three/drei';
import { useFrame } from '@react-three/fiber';
import React, { useRef } from 'react';
import montserrat from '../montserrat.json'

export default function FourOFour(){

    const textOptions = {
        size:20,
        curveSegments:96,
        bevelEnabled: true,
        bevelThickness:3.6,
        bevelSize:2,
        bezelOffset: 0,
        bevelSegments:80,
    }

    return (
        <Center >
            <Text3D {...textOptions} position={[4.75, 0, -120.25]} scale={[.85, .85, .85]} rotation={[0,0,0]} font={montserrat}>
                404
                <meshStandardMaterial metalness={1} color={'#7c7c7c'} roughness={.025}/>
            </Text3D>
        </Center>
    )
}

